import { Link } from "react-router-dom";
import { APPLE_EULA_URL } from "@/components/TermsAcceptanceGate";

const linkCls = "underline underline-offset-2 text-rose-300 hover:text-rose-200";

export function SubscriptionLegalLinks({ testid = "sub" }) {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs" data-testid={`${testid}-legal-links`}>
      <Link to="/legal/privacy-policy" className={linkCls} data-testid={`${testid}-privacy-link`}>Privacy Policy</Link>
      <a href={APPLE_EULA_URL} target="_blank" rel="noreferrer" className={linkCls} data-testid={`${testid}-eula-link`}>Terms of Use (Apple Standard EULA)</a>
      <Link to="/legal/terms-of-service" className={linkCls} data-testid={`${testid}-terms-link`}>My Panda X Terms</Link>
    </div>
  );
}

